import { gql } from '@apollo/client';

/**
 * 司机反馈跟进列表（按 hub）。对应 api-server PickupReviewPoolQuery.getDriverFeedbackListing。
 */
export const GET_DRIVER_FEEDBACK_LISTING = gql`
  query GetDriverFeedbackListing($hubId: Long!, $pageNo: Int!, $pageSize: Int!) {
    getDriverFeedbackListing(hubId: $hubId, pageNo: $pageNo, pageSize: $pageSize) {
      items {
        siteId
        siteName
        addressLine1
        addressLine2
        city
        state
        zipcode
        country
        dock
        channelIdsJson
        linkStatus
        driverName
        feedbackTime
        onsiteContacted
        onsiteContactName
        onsiteContactPhone
        siteContactName
        siteContactPhone
        driverNote
        photoCount
        hasNewFeedback
        siteCreatedAt
        channelNames
      }
      total
      todayNewCount
      pendingOnsiteCount
      onsiteInProgressCount
      pickupSuccessPendingCount
      pickupFailedPendingCount
    }
  }
`;

export interface DriverFeedbackItemDto {
  siteId: number | null;
  siteName: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  zipcode: string | null;
  country: string | null;
  dock: string | null;
  channelIdsJson: string | null;
  linkStatus: number | null;
  driverName: string | null;
  feedbackTime: string | null;
  onsiteContacted: boolean;
  onsiteContactName: string | null;
  onsiteContactPhone: string | null;
  siteContactName: string | null;
  siteContactPhone: string | null;
  driverNote: string | null;
  photoCount: number;
  hasNewFeedback: boolean;
  siteCreatedAt: string | null;
  channelNames: string[] | null;
}

export interface GetDriverFeedbackListingResponse {
  getDriverFeedbackListing: {
    items: DriverFeedbackItemDto[];
    total: number;
    todayNewCount: number;
    /**
     * 建联状态页签角标（2.2 需求点6）。口径与 `total` 一致（同 hub、同跟进过滤），
     * **不随分页、也不随前端的关键字/日期筛选变化** —— 本接口 pageSize 固定 200，
     * 跟进量超过 200 时在前端按 items 数就会少算，所以必须用这四个后端值。
     */
    pendingOnsiteCount: number;
    onsiteInProgressCount: number;
    pickupSuccessPendingCount: number;
    pickupFailedPendingCount: number;
  };
}
